import { ReactNode } from 'react';


interface IContainerMembrosProps {
    children: ReactNode;
}

const ContainerMembros = ({ children }: IContainerMembrosProps) => {
    return (
        <div className='mt-10 flex flex-col gap-10'>
            {children}
        </div>
    );
}

export { ContainerMembros };